import { render, staticRenderFns } from "./publicDetail.vue?vue&type=template&id=f3e5c21e&scoped=true"
import script from "./publicDetail.vue?vue&type=script&lang=js"
export * from "./publicDetail.vue?vue&type=script&lang=js"
import style0 from "./publicDetail.vue?vue&type=style&index=0&id=f3e5c21e&prod&lang=scss&scoped=true"
import style1 from "./publicDetail.vue?vue&type=style&index=1&id=f3e5c21e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e5c21e",
  null
  
)

export default component.exports